import { Component, input, viewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorComponent, AngularEditorModule } from '@kolkov/angular-editor';
import { UserReplacePipe } from '../../pipes/user-replace.pipe';

@Component({
  selector: 'app-editor',
  imports: [ReactiveFormsModule, AngularEditorModule, UserReplacePipe],
  templateUrl: './editor.component.html',
  styleUrl: './editor.component.scss'
})
export class EditorComponent {
  readonly form = input.required<FormGroup>();
  readonly disabled = input<boolean>(false);
  readonly controlName = input.required<string>();
  editorConfig = {
    editable: true,
    spellcheck: true,
    height: '250px',
    minHeight: '250px',
    sanitize: false,
    placeholder: '...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ]
  };

  readonly editor = viewChild.required<AngularEditorComponent>('editor');
}
